import { render, staticRenderFns } from "./PromotionGood.vue?vue&type=template&id=3df48802&scoped=true&"
import script from "./PromotionGood.vue?vue&type=script&lang=js&"
export * from "./PromotionGood.vue?vue&type=script&lang=js&"
import style0 from "./PromotionGood.vue?vue&type=style&index=0&id=3df48802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df48802",
  null
  
)

export default component.exports